// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-login-reset',
    data: () => ({
        userID: "",
        code: "",
        password1: "",
        password2: "",
        errorMessage: ""
    }),
    created() {
        this.userID = this.$route.query.userid;
        this.code = this.$route.query.code;
    },
    computed: {
        hasError() {
            return !utils.isEmpty(this.errorMessage);
        },
    },
    methods: {
        OnExecute() {
            if (utils.isEmpty(this.password1)) {
                return;
            }
            if (this.password1 != this.password2) {
                return;
            }
            var tBody = {
                userID: this.userID,
                code: this.code,
                password: this.password1
            };
            appHost.api.post(`identity/profile/password-reset`, tBody)
                .then((e) => {
                this.$router.push({ path: '/login/reset', hash: '#submit' });
            })
                .catch((e) => {
                this.errorMessage = e.response.data.message;
            });
        },
        OnBack() {
            this.$router.push({ path: '/login' });
        }
    }
});
// #endregion
